import { takeLatest, put, call, SagaReturnType } from 'redux-saga/effects';
import { documentationActions } from '../../actions/constant';
import templateService from 'src/services/apiServices/document-management/template-service';

const {
  REQUEST_GET_TARGET_SIGNATURE_ACCESS,
  SUCCESS_GET_TARGET_SIGNATURE_ACCESS,
  FAILURE_GET_TARGET_SIGNATURE_ACCESS,
} = documentationActions;

/**
 * BRK-2074: the need-supervision maps for an on-behalf-create TARGET — the same endpoint as
 * getSignatureAccessSaga with the BRK-2072 `providerId` param riding in `action.params` (the
 * backend resolves the target's roles itself; the roles body is ignored on that branch).
 * takeLatest: the actor can re-pick the target in the dialog, and only the last pick's maps
 * may win.
 */
function* getTargetAccess(action: any): SagaReturnType<any> {
  try {
    const response = yield call(templateService.getSignatureAccess, action.payload, action.params);
    if (response?.status === 200) {
      yield put({ type: SUCCESS_GET_TARGET_SIGNATURE_ACCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_GET_TARGET_SIGNATURE_ACCESS, payload: error });
  }
}

function* getTargetSignatureAccessSaga() {
  yield takeLatest(REQUEST_GET_TARGET_SIGNATURE_ACCESS, getTargetAccess);
}

export default getTargetSignatureAccessSaga;
